import { render } from "./DocumentClassListView.vue?vue&type=template&id=3cce7c76&ts=true"
import script from "./DocumentClassListView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassListView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__